import styled$1, { css, ThemeContext } from 'styled-components';
import { colorSet, useWindowEvent } from '@ccg/core';
import React$1, { useContext, useState, useRef, useEffect } from 'react';
import { getOuterGridContainer, getInnerGridContainer, getGrid } from '../Grid/Grid.js';

const ResizeGridContainer = styled$1.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  box-sizing: border-box;
  opacity: 1;
  pointer-events: none;
  transition: opacity 0.4s ease-in-out;
  z-index: 999;
`;
const ResizeGridOuter = styled$1.div`
  width: 100%;
  height: 100%;
  ${getOuterGridContainer()}
`;
const ResizeGridInner = styled$1.div`
  ${getInnerGridContainer()}
  height: 100%;
`;
const ResizeGridContent = styled$1.div`
  ${getGrid()}
  height: 100%;
  outline: 1px solid ${colorSet('accent')};

  ${props => props.hidden && css(["opacity:0;"])}
  .resizeGrid__column {
    position: relative;
    opacity: 0.5;
    display: inline-block;
    height: 100%;
    box-sizing: border-box;
    margin: 0 -1px;
    border-left: 1px solid ${colorSet('accent')};
    border-right: 1px solid ${colorSet('accent')};
  }
`;

const createColumns = grid => {
  const columns = [];

  for (let i = 0; i < grid.columns.m; i += 1) {
    columns.push( /*#__PURE__*/React$1.createElement("div", {
      key: i,
      className: "resizeGrid__column"
    }));
  }

  return columns;
};

const ResizeGrid = () => {
  const {
    grid
  } = useContext(ThemeContext);
  const [visible, setVisible] = useState(false);
  const prevWidth = useRef();
  useEffect(() => {
    prevWidth.current = window.innerWidth;
  }, []);
  useEffect(() => {
    let timeout;

    if (visible) {
      timeout = setTimeout(() => setVisible(false), 2000);
    }

    return () => clearTimeout(timeout);
  }, [visible]);
  useWindowEvent('resize', () => {
    if (prevWidth.current !== window.innerWidth) {
      prevWidth.current = window.innerWidth;
      if (!visible) setVisible(true);
    }
  });
  return /*#__PURE__*/React$1.createElement(ResizeGridContainer, null, /*#__PURE__*/React$1.createElement(ResizeGridOuter, null, /*#__PURE__*/React$1.createElement(ResizeGridInner, null, /*#__PURE__*/React$1.createElement(ResizeGridContent, {
    hidden: !visible,
    columns: grid.columns
  }, createColumns(grid)))));
};

export default ResizeGrid;
